var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 23.5H5C3.07614 23.5 1.5 21.9239 1.5 20V1C1.5 0.813624 1.55994 0.697164 1.62855 0.628553C1.69716 0.559943 1.81362 0.5 2 0.5C2.18638 0.5 2.30284 0.559943 2.37145 0.628553C2.44006 0.697164 2.5 0.813624 2.5 1V20C2.5 21.3761 3.62386 22.5 5 22.5H24C24.1864 22.5 24.3028 22.5599 24.3714 22.6286C24.4401 22.6972 24.5 22.8136 24.5 23C24.5 23.1864 24.4401 23.3028 24.3714 23.3714C24.3028 23.4401 24.1864 23.5 24 23.5Z",
    fill: "#757575",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 19.5C5.81362 19.5 5.69716 19.4401 5.62855 19.3714C5.55994 19.3028 5.5 19.1864 5.5 19V14C5.5 13.8136 5.55994 13.6972 5.62855 13.6286C5.69716 13.5599 5.81362 13.5 6 13.5C6.18638 13.5 6.30284 13.5599 6.37145 13.6286C6.44006 13.6972 6.5 13.8136 6.5 14V19C6.5 19.1864 6.44006 19.3028 6.37145 19.3714C6.30284 19.4401 6.18638 19.5 6 19.5Z",
    fill: "#757575",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19.5C9.81362 19.5 9.69716 19.4401 9.62855 19.3714C9.55994 19.3028 9.5 19.1864 9.5 19V10C9.5 9.81362 9.55994 9.69716 9.62855 9.62855C9.69716 9.55994 9.81362 9.5 10 9.5C10.1864 9.5 10.3028 9.55994 10.3714 9.62855C10.4401 9.69716 10.5 9.81362 10.5 10V19C10.5 19.1864 10.4401 19.3028 10.3714 19.3714C10.3028 19.4401 10.1864 19.5 10 19.5Z",
    fill: "#757575",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19.5C13.8136 19.5 13.6972 19.4401 13.6286 19.3714C13.5599 19.3028 13.5 19.1864 13.5 19V12C13.5 11.8136 13.5599 11.6972 13.6286 11.6286C13.6972 11.5599 13.8136 11.5 14 11.5C14.1864 11.5 14.3028 11.5599 14.3714 11.6286C14.4401 11.6972 14.5 11.8136 14.5 12V19C14.5 19.1864 14.4401 19.3028 14.3714 19.3714C14.3028 19.4401 14.1864 19.5 14 19.5Z",
    fill: "#757575",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19.5C17.8136 19.5 17.6972 19.4401 17.6286 19.3714C17.5599 19.3028 17.5 19.1864 17.5 19V7C17.5 6.81362 17.5599 6.69716 17.6286 6.62855C17.6972 6.55994 17.8136 6.5 18 6.5C18.1864 6.5 18.3028 6.55994 18.3714 6.62855C18.4401 6.69716 18.5 6.81362 18.5 7V19C18.5 19.1864 18.4401 19.3028 18.3714 19.3714C18.3028 19.4401 18.1864 19.5 18 19.5Z",
    fill: "#757575",
    stroke: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 19.5C21.8136 19.5 21.6972 19.4401 21.6286 19.3714C21.5599 19.3028 21.5 19.1864 21.5 19V13C21.5 12.8136 21.5599 12.6972 21.6286 12.6286C21.6972 12.5599 21.8136 12.5 22 12.5C22.1864 12.5 22.3028 12.5599 22.3714 12.6286C22.4401 12.6972 22.5 12.8136 22.5 13V19C22.5 19.1864 22.4401 19.3028 22.3714 19.3714C22.3028 19.4401 22.1864 19.5 22 19.5Z",
    fill: "#757575",
    stroke: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.d6431dd6.svg";
export { ForwardRef as ReactComponent };